<template>
  <div id="app">
    <header-el></header-el>
    <div class="init-page">
      <div class="top">
        <img src="http://images.kaishiba.com/init-top-bg.png" alt>
      </div>
      <div class="content">
        <section>
          <h3>
            1.请选择项目类型
            <span class="require">*</span>
            <span class="tips">明确的项目类型有助于用户快速的找到你的项目</span>
          </h3>
          <ul class="type-list">
            <li
              :class="'ani-index-li '+(project.Category==category.Value?'actived-id':'')"
              v-for="(category,index) in categroyData" v-bind:key="index"
              v-on:click="confirmCategory(category.Value)"
            >
              <i
                class="select-icon ivu-icon ivu-icon-checkmark-round"
                v-show="project.Category==category.Value"
              ></i>
              <img src="http://images.kaishiba.com/src/png/minsu2x_3.png">
              <p class="type">{{category.DisplayName}}</p>
              <p class="desc">{{category.Description}}</p>
            </li>
          </ul>
        </section>
        <section>
          <h3>
            2.请填写项目基础信息
            <span class="require">*</span>
          </h3>
          <div class="flex-box" style="flex-wrap: wrap; justify-content: space-between;">
            <div class="base-info" style="margin-right: 20px;">
              <p class="label-name">品牌名称（或项目名称）：</p>
              <div class="input-box">
                <input maxlength="30" placeholder="有辨识度的品牌名称有助于项目推广" v-model="project.Name">
              </div>
            </div>
            <div class="base-info">
              <p class="label-name">项目所在地：</p>
              <div class="input-box">
                <input v-model="project.Address" placeholder="项目所在地区">
              </div>
            </div>
            <div class="base-info">
              <p class="label-name">开业时间（或活动举办时间）</p>
              <div class="input-box">
                <!-- <DatePicker type="date" placeholder="Select date" style="width: 200px"></DatePicker> -->
                <div class="ivu-date-picker" style="width: 100%; margin-top: 13px;">
                  <div class="ivu-date-picker-rel">
                    <div class="ivu-input-wrapper ivu-input-type ivu-date-picker-editor">
                      <!---->
                      <i
                        class="ivu-icon ivu-icon-ios-calendar-outline ivu-input-icon ivu-input-icon-normal"
                      ></i>
                      <!---->
                      <input
                        autocomplete="off"
                        spellcheck="false"
                        type="text"
                        placeholder="如尚未开始请选择预计开始时间"
                        class="ivu-input"
                        v-model="project.StartTime"
                      >
                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <h3>
            3.请选择项目类型
            <span class="require">*</span>
          </h3>
          <div>
            <div class="ivu-radio-group">
              <label class="ivu-radio-wrapper ivu-radio-group-item">
                <input
                  type="radio"
                  name="ivuRadioGroup_1560927210348_0"
                  v-model="project.ProfitCategory"
                  value="0"
                >权益类（股权/分红权转让）
              </label>
              <label class="ivu-radio-wrapper ivu-radio-group-item">
                <input
                  type="radio"
                  name="ivuRadioGroup_1560927210348_0"
                  v-model="project.ProfitCategory"
                  value="1"
                >广告类（售卖产品/加盟代理）
              </label>
            </div>
          </div>
        </section>
        <section>
          <h3>
            4.是否拥有营业场地？
            <span class="require">*</span>
          </h3>
          <div>
            <div class="ivu-radio-group">
              <label class="ivu-radio-wrapper ivu-radio-group-item">
                <input
                  type="radio"
                  v-model="project.IsHavePlace"
                  name="ivuRadioGroup_1560927210348_1"
                  value="true"
                >是
              </label>
              <label class="ivu-radio-wrapper ivu-radio-group-item">
                <input
                  type="radio"
                  v-model="project.IsHavePlace"
                  name="ivuRadioGroup_1560927210348_1"
                  value="false"
                >否
              </label>
            </div>
          </div>
        </section>
        <section>
          <h3>
            5.是否有独立运营该项目及财务核算的公司？
            <span class="require">*</span>
          </h3>
          <div>
            <div class="ivu-radio-group">
              <label class="ivu-radio-wrapper ivu-radio-group-item">
                <input
                  type="radio"
                  v-model="project.IsDependent"
                  name="ivuRadioGroup_1560927210348_2"
                  value="true"
                >是
              </label>
              <label class="ivu-radio-wrapper ivu-radio-group-item">
                <input
                  type="radio"
                  v-model="project.IsDependent"
                  name="ivuRadioGroup_1560927210348_2"
                  value="false"
                >否
              </label>
            </div>
          </div>
        </section>
        <section>
          <h3>
            6.请上传项目图片（场景图片、设计图片等）
            <span class="require">*</span>
            <span class="tips">单个文件大小不超过 10M</span>
          </h3>
          <div>
            <ul class="flex-box img-list">
              <li class="add-img" style="position: relative;">
                <input
                  type="file"
                  id="uploadFile"
                  class="uploadFile"
                  multiple
                  accept="image/jpeg, image/png, image/gif"
                  value="请选择文件"
                  @change="handleFileChange"
                  ref="uploadImage"
                >
                <label for="uploadFile" class="uploadlabelid">
                  <span class="icon-kaistart-circle-plus"></span>
                  <span>上传图片</span>
                  <span>{{imagesCount}}/8</span>
                </label>
              </li>
            </ul>
            <ul class="flex-box img-list">
              <li v-for="img in images" v-bind:key="img">
                <img :src="img">
              </li>
            </ul>
          </div>
        </section>
        <section>
          <h3>
            7.请介绍项目核心团队
            <span class="require">*</span>
            <span class="tips">至少1位，最多6位</span>
          </h3>
          <div style="overflow: hidden;">
            <div
              class="flex-box mb40"
              style="flex-wrap: wrap; position: relative;"
              v-for="(team,index) in project.Teams" v-bind:key="index"
            >
              <!---->
              <img
                v-on:click="removeTeam(index)"
                v-show="project.Teams.length>1"
                src="data:image/png;base64,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"
                class="delete-member-icon"
              >
              <div class="input-box" style="width: 162px; margin-right: 27px; margin-top: 0px;">
                <input placeholder="姓名" maxlength="30" v-model="team.Name">
              </div>
              <div class="input-box" style="width: 162px; margin-top: 0px;">
                <input placeholder="团队角色" maxlength="30" v-model="team.Role">
              </div>
              <div class="input-box" style="width: 980px; height: 99px;">
                <textarea placeholder="请填写团队成员背景" maxlength="100" v-model="team.Profile"></textarea>
                <p class="num">
                  <span class>0</span>/
                  <span>100</span>
                </p>
              </div>
            </div>
            <div class="input-box flex-box add-bt" v-on:click="addTeam">
              <span
                class="icon-kaistart-circle-plus"
                style="color: rgb(99, 97, 97); font-size: 16px; margin-right: 5px;"
              ></span>
              <span>添加成员</span>
            </div>
          </div>
        </section>
        <section>
          <h3>
            8.请简单介绍你的项目
            <span class="require">*</span>
          </h3>
          <p
            class="intro-tips"
          >项目介绍是我们进行评判的重要标准。你可以介绍项目的区位优势、总投资金额、营业或种植面积、近一年收入及净利润、销售渠道构成中的电商占比、客单价等（连锁店铺可用老店数据），也可以从现有资源及流量、商业模式、创新点、过往项目情况/数据等多方面介绍。</p>
          <div>
            <div class="input-box" style="width: 980px; height: 99px; position: relative;">
              <textarea
                placeholder="我的项目位于浙江省杭州市西子湖畔..."
                maxlength="300"
                v-model="project.About"
                @input="inputabout"
              ></textarea>
              <p class="num" style="right: 11px; bottom: 0px;">
                <span class>{{aboutLength}}</span>/
                <span>300</span>
              </p>
            </div>
          </div>
        </section>
        <section>
          <div class="check-box">
            <input type="checkbox" v-model="isagree">
            <span>我承诺以上各项内容属实</span>
            <span style="color: rgb(153, 153, 153);">(勾选后才可保存或提交审核)</span>
          </div>
        </section>
        <section>
          <div class="bt-box">
            <span class="ksui-btn save-bt" v-on:click="saveSubmit">保存</span>
            <!-- <span class="ksui-btn update-bt">提交审核</span> -->
          </div>
        </section>
      </div>
    </div>
    <footer-el></footer-el>
    <div id="islogin" v-if="user==null">
      <div class="dislogin">
        <a href="/login">请先登录</a>
      </div>
    </div>
  </div>
</template>


<script>
import Headers from "../components/header";
import Footer from "../components/footer";
import { mapState } from "vuex";

export default {
  name: "app",
  components: {
    "header-el": Headers,
    "footer-el": Footer
  },
  data() {
    return {
      categroyData: [],
      isagree: false,
      aboutLength: 0,
      images: [],
      project: {
        Category: 0,
        Teams: [{}],
        Profile: "",
        Images: [],
        IsDependent: true,
        IsHavePlace: true,
        UserID:0
      }
    };
  },
  methods: {
    getCategory() {
      fetch(host + "/api/crowdfunding/project/category", {
        method: "get",
        mode:"no-cors",
        credentials: "include",
        body: {}
      })
        .then(response => response.json())
        .then(data => {
          if (data.Success) {
            this.categroyData = data.Data;
          }
        })
        .catch(ex => console.log(ex));
    },
    confirmCategory(id) {
      console.log(id);
      this.project.Category = id;
    },
    addTeam() {
      this.project.Teams.push({});
    },
    removeTeam(index) {
      if (index == 0) {
        return;
      }
      this.project.Teams.splice(index, 1);
    },
    saveSubmit() {
      if (this.isagree == false) {
        alert("请确认内容属实");
        return;
      }
      if (this.project.Category == 0) {
        alert("请选择分类");
        return;
      }
      if (this.project.Name == "") {
        alert("请填写项目名称");
        return;
      }
      if (this.project.Address == "") {
        alert("请填写项目地址");
        return;
      }
      if (this.project.StartTime == "") {
        alert("请填写项目时间");
        return;
      }
      if (this.images.length == 0) {
        alert("请上传项目图片");
        return;
      }
      if (this.project.Teams.length == 0) {
        alert("请填写项目团队");
        return;
      }
      if (this.project.About == "") {
        alert("请填写项目介绍");
        return;
      }
      console.log(this.project);
      this.project.Images = this.images;
      this.project.UserID=this.user.ID;
      fetch(host + "/api/crowdfunding/idea/add", {
        method: "POST",
        //mode: "cors",
        //credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(this.project) //{ "idea": }
      })
        .then(response => response.json())
        .then(data => {
          console.log(data);
          if (data.Success) {
            alert("添加成功，稍后将与您进一步沟通");
            window.location = window.location;
            return;
          } else {
            alert(data.Message);
          }
        })
        .catch(ex => {
          console.log(ex);
        });
    },
    inputabout: function() {
      this.aboutLength = this.project.About.length;
    },
    showImage: function(file) {
      let self = this;
      //看是否支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        //创建一个Reader
        var reader = new FileReader();
        //将图片转换成base64 格式
        reader.readAsDataURL(file);
        //读取成功后回调
        reader.onloadend = function() {
          self.images.push(this.result);
        };
      }
    },
    handleFileChange: function() {
      var inputDom = this.$refs.uploadImage;
      var files = inputDom.files;
      if (files.length >= 8) {
        alert("最多只能上传8张");
        return;
      }
      for (var i = 0; i < files.length; i++) {
        this.showImage(files[i]);
      }
    }
  },
  computed: {
    // ProfileLength:this.project.Profile.length
    imagesCount: function() {
      return this.images.length;
    },
    ...mapState({
      user: state => {
        var u = state.myuser.user;
       
        // if (u != null) {
        //   console.log(this.project);
        //   //this.project.UserID = u.User.ID;
        // }
        return u;
      }
    })
  },
  created: function() {
    this.getCategory();
    //console.log(this.user);
    // this.project.UserID=this.user.user.ID;
  }
};
</script>




<style  scoped>
@import url("../css/initProject.css");

#islogin {
  position: fixed;
  width: 100%;
  opacity: 0.5;
  top: 0px;
  bottom: 0px;
  background-color: #ccc;
  text-align: center;
  font-size: 30px;
  line-height: 10%;
}
.dislogin {
  position: relative;
  vertical-align: middle;
  margin-top: 30%;
  opacity: 100;
  background-color: #fff;
  height: 60px;
  line-height: 60px;
  width: 130px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
#islogin a {
  opacity: 100;
  color: #03561a;
}

input.uploadFile {
  /* font-size: 0; */
  /* 为了去掉‘未选择任何文件’这几个字，也可以随便弄到哪里*/
  position: absolute;
  left: -9999px;
}

.uploadlabelid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  padding: 30px;
}

.uploadlabelid span {
  display: block;
  line-height: 2.5;
}

/* 注意不是直接input > input[type=button] 哦*/
input::-webkit-file-upload-button {
  background: #efeeee;
  color: #333;
  border: 0;
  padding: 68px 92px;
  border-radius: 5px;
  font-size: 12px;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1), 0 0 10px rgba(0, 0, 0, 0.12);
}
</style>

